import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserUniqBuilding } from '../../../reducers/userDataReducer'
import { getAmenities, selectAmenities } from '../../../reducers/Organisation/reservationsReducer'

import AmenityBox from './AmenityBox'
import AmenityDetailsSidebar from './AmenityDetailsSidebar'

const ClientReservationsAmenities = ({ amenities, getAmenities, buildingData }) => {
  const { t } = useTranslation(['client-reservations'])
  const [selectedAmenity, setSelectedAmenity] = useState(null)

  useEffect(() => {
    if (buildingData) {
      fetchAmenities()
    }
  }, [])

  const fetchAmenities = async () => {
    try {
      await getAmenities(buildingData ? buildingData.id : undefined)
    } catch ({ message }) {
      console.error(message)
    }
  }

  return (
    <div className="client-reservations-container">
      <div className="client-reservations-amenities">
        {amenities.length ? (
          amenities
            .filter((amenity) => !amenity.hidden)
            .map((amenity) => (
              <AmenityBox
                key={amenity.id}
                amenity={amenity}
                onClick={(selected) => setSelectedAmenity(selected)}
                selectedAmenity={selectedAmenity}
              />
            ))
        ) : (
          <div>{t('client-reservations:amenities.noneAvailable')}</div>
        )}
      </div>
      {selectedAmenity ? <AmenityDetailsSidebar amenity={selectedAmenity} /> : null}
    </div>
  )
}

ClientReservationsAmenities.propTypes = {
  amenities: PropTypes.array,
  getAmenities: PropTypes.func,
  buildingData: PropTypes.object,
}

export default connect(
  (state) => ({
    amenities: selectAmenities(state),
    buildingData: selectUserUniqBuilding(state),
  }),
  { getAmenities },
)(ClientReservationsAmenities)
